import React from 'react';
import { AddCircle, MinusCirlce } from '@myua/icons/dist/bulk24';
import { useDispatch, useSelector } from 'react-redux';
import * as sharingActions from '../../../sharing/actions';
import { isHeaderCellChecked } from '../../../sharing/selectors';
import { getTableData } from '../../selectors/getTableData';

export const ShareSelectorHeader = () => {
  const nodes = useSelector(getTableData);
  const isChecked = useSelector(isHeaderCellChecked);
  // Миш, если есть желание покопаться в этом баге — можем обсудить
  // Короче говоря, при переключении режимов между "папка" и "шара"
  // в таблице меняется целая колонка:
  // https://gitlab.pvt/gapa/myua/front/creative-hub/-/blob/2e2f054250579b792cb4486e676219fce4bf18e9/src/creativeHub/modules/fileManager/getColumns.ts#L21
  // соответственно компонент в хедере меняется с SelectorHeader на этот
  // и !!! реакт падает, потому что там и тут хуки идут в разном порядке
  // вот этот ⬇️ костыль всего лишь "выравнивает" порядок хуков в этих компонентах
  // по идее компоненты можно объединить, но это тупо с точки зрения бизнес-логики,
  // потому что выбранные ноды в папках и в шарах хранятся по-разноиму
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const _isChecked2 = useSelector(isHeaderCellChecked);
  const dispatch = useDispatch();

  const onChange = () =>
    isChecked
      ? dispatch(sharingActions.shareSelectorAllUnchecked({ nodes }))
      : dispatch(sharingActions.shareSelectorAllChecked({ nodes }));

  return (
    <div
      className={`ch-share-selector-icon ch-share-selector-icon_selected-${isChecked}`}
      onClick={onChange}
    >
      {isChecked ? <MinusCirlce /> : <AddCircle />}
    </div>
  );
};
